import * as React from 'react'
import { CompressOutlined } from '@ant-design/icons'
import { Card, Col, List, PageHeader, Row } from 'antd'
import { RouteComponentProps, withRouter } from 'react-router'
import moment from 'moment'

import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import container from '../../wires/Bootstrapper'

import { ElencoPianiPrevisionaliModel } from '../../models/PianoPrevisionaleModels'
import { IPianoPrevisionaleService } from '../../services/PianoPrevisionaleService'

interface PianoPrevisionaleProps {
    clienteId?: string
    anno: number
}

class ElencoPianiPrevisionaliModelState extends ElencoPianiPrevisionaliModel {

}

class PianoPrevisionaleComp extends React.Component<RouteComponentProps & PianoPrevisionaleProps, ElencoPianiPrevisionaliModelState> {

    service: IPianoPrevisionaleService

    constructor(props) {
        super(props)
        this.state = new ElencoPianiPrevisionaliModelState()
        this.service = container.get(SERVICE_IDENTIFIER.PIANO_PREVISIONALE)
    }

    componentDidMount() {
        this.loadList()
    }

    loadList = async () => {
        let data = await this.service.GetPianiPrevisionaliList(this.props.clienteId)
        if (data.IsValid == true)
            this.setState(data)
    }


    renderPiani = () => {
        if (this.state.ListaPiano == null) return
        return this.state.ListaPiano.map(piano =>
            <Col xl={6} key={piano.Id} >
                <Card title={"Anno: " + piano.Anno} extra={<a href={`/PianoPrevisionale/Dettaglio/${piano.Id}` } >Dettagli</a>} style={{ width: 300 }}>
                    <p><strong>Fatturato</strong>: € {piano.FatturoPrevisto.toLocaleString("it-IT", { minimumFractionDigits: 2 })}</p>
                    <p><strong>Incassato</strong>: € {piano.IncassatoPrevisto.toLocaleString("it-IT", { minimumFractionDigits: 2 })}</p>
                    <p><strong>Costi fissi</strong>: {piano.CostiFissiPercentuale}%</p>
                    <p><strong>Costi variabili</strong>: {piano.CostiVariabiliPercentuale}%</p>
                </Card>
            </Col>
        )
    }

    render() {
        return (
            <>
                <PageHeader title="Piano Previsionale"></PageHeader>
                {
                    <Row gutter={[20, 20]}>
                        {this.renderPiani()}
                    </Row>
                }
            </>
        )
    }
}

export const PianoPrevisionale = withRouter(PianoPrevisionaleComp)